import { util } from 'echarts/core';
import { overrideIfUndefined } from '../../../util/data';
import { normalizeToArray } from '../../../util/utils';
import { type ThemeParser } from '../../../core/theme';
// import { fontColor, FONT_LEVEL_LIST } from '../static/font';
import {
  fontColor,
  FONT_LEVEL_LIST,
  FONT_SIZE_LIST,
  FONT_WEIGHT_LIST,
  THS_FONTFAMILY_MEDIUM
} from '../static/font';

function parseXAxisLine(colorMode: 'light' | 'dark', ...args: Parameters<ThemeParser>) {
  const [option, , optionToken] = args;
  const xAxisArr = normalizeToArray(option.xAxis);
  // data中数据供x轴使用
  const axisLabelColor = fontColor(FONT_LEVEL_LIST.LEVEL2, colorMode);
  const axisLabelFontSize = FONT_SIZE_LIST.axisLabel;
  const axisLabelWeight = FONT_WEIGHT_LIST.axisLabel;
  /** UI规范，x轴标签和轴线的距离默认为4px 字体本身有偏移所以设成6px */
  const DEFAULT_AXISLABEL_MARGIN = 6;
  xAxisArr.forEach(xAxis => {
    xAxis.axisLine = util.merge(
      {
        show: false,
        width: 0.5
      },
      xAxis.axisLine || {},
      true
    );
    xAxis.axisTick = util.merge({ show: false }, xAxis.axisTick || {}, true);
    xAxis.axisLabel = util.merge(
      {
        color: axisLabelColor,
        fontSize: axisLabelFontSize,
        fontFamily: THS_FONTFAMILY_MEDIUM,
        fontWeight: axisLabelWeight,
        margin: DEFAULT_AXISLABEL_MARGIN
      },
      xAxis.axisLabel || {},
      true
    );
  });
}

function parseXAxisLabelDvAlignEdge(option: Parameters<ThemeParser>[0]) {
  const xAxisArr = normalizeToArray(option.xAxis);
  xAxisArr.forEach(element => {
    element.axisLabel = overrideIfUndefined(element.axisLabel, {});
    element.axisLabel.dvAlignEdge = overrideIfUndefined(element.axisLabel.dvAlignEdge, true);
  });
}

function xAxisParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  option.xAxis = overrideIfUndefined(option.xAxis, {
    axisLabel: {
      dvAlignEdge: false
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    }
  });
  parseXAxisLabelDvAlignEdge(option);
}

export function xAxisThemeParse(...args: Parameters<ThemeParser>) {
  const [, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  parseXAxisLine(themeMode, ...args);
  xAxisParse(...args);
}
